import { Box, Card } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type HeadcountByTeam from 'modules/insights/lib/metrics/headcountByTeam'

import BlankSlate from '../BlankSlate'
import HeadcountByTeamChart from './HeadcountByTeamChart'

type Props = {
  headcountByTeam: HeadcountByTeam
}

const WidgetHeadcountByTeam = ({ headcountByTeam }: Props) => (
  <Card>
    <Card.Title tooltip={i18n.t('insights.widgets.headcount_by_team.tooltip')}>
      {i18n.t('insights.widgets.headcount_by_team.title')}
    </Card.Title>
    <Card.Content>
      {headcountByTeam.isEmpty() ? (
        <BlankSlate />
      ) : (
        <Box maxHeight="s600" width="full" overflowY="auto">
          <HeadcountByTeamChart headcountByTeam={headcountByTeam} />
        </Box>
      )}
    </Card.Content>
  </Card>
)

export default WidgetHeadcountByTeam
